import React from 'react'

interface IconProps {
  name: string
  alt: string
  size?: number
  className?: string
}

const Icon: React.FC<IconProps> = ({
  name,
  alt,
  size = 20,
  className = '',
}) => {
  const sizeStyle = {
    width: `${size}px`,
    height: `${size}px`,
  }

  return (
    <div className={`inline-block ${className}`} style={sizeStyle}>
      <img src={`/${name}.png`} alt={alt} width={size} height={size} />
    </div>
  )
}

export default Icon
